module.exports = __webpack_public_path__ + "img/verticle-share-report.f67f568c.png";